import {
  OPEN_DIALER,
  CLOSE_DIALER,
  TOGGLE_DIALER,
  UPDATE_CALL_STATUS,
  SET_PHONE_NUMBER,
} from "../types/globalDialer.types";

export const openDialer = (phoneNumber) => ({
  type: OPEN_DIALER,
  payload: phoneNumber,
});

export const closeDialer = () => ({
  type: CLOSE_DIALER,
});

export const toggleDialer = () => ({
  type: TOGGLE_DIALER,
});

export const updateCallStatus = (status, data = null) => ({
  type: UPDATE_CALL_STATUS,
  payload: { status, data },
});

export const setPhoneNumber = (phoneNumber) => ({
  type: SET_PHONE_NUMBER,
  payload: phoneNumber,
});
